import React, { useState } from 'react';
import { Insight, InsightIcon } from '../aiInsightsTypes';
import { SuggestedReorderModal } from './SuggestedReorderModal';
import styles from './InsightCard.module.css';

interface InsightCardProps {
  insight: Insight;
}

const icons: Record<InsightIcon, string> = {
  reorder: '📦',
  churn: '⚠️',
  upsell: '↗',
  visit: '📅',
  crosssell: '📈',
  demand: '📊',
};

export const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  const tagKey = insight.tag.toLowerCase();
  const isReorder = insight.icon === 'reorder';
  const [showReorderModal, setShowReorderModal] = useState(false);
  return (
    <div className={styles.card}>
      <span className={`${styles.iconBox} ${styles[`color_${insight.iconColor}`]}`}>
        {icons[insight.icon]}
      </span>
      <div className={styles.body}>
        <div className={styles.headerRow}>
          <div>
            <p className={styles.title}>{insight.title}</p>
            <p className={styles.customer}>{insight.customer}</p>
          </div>
          <div className={styles.tagsCol}>
            {insight.tag === 'NEW' && <span className={styles.newTag}>NEW</span>}
            <span className={`${styles.tag} ${styles[`tag_${tagKey}`]}`}>{insight.tag}</span>
          </div>
        </div>
        <p className={styles.cardBody}>{insight.body}</p>
        <p className={styles.recommendation}>
          <span className={styles.recLabel}>Recommendation:</span> {insight.recommendation}
          {insight.recommendationValue && (
            <span className={styles.recValue}> · {insight.recommendationValue}</span>
          )}
        </p>
        <div className={styles.footerRow}>
          <span className={styles.confidence}>{insight.confidence}</span>
          <button
            className={styles.cta}
            onClick={isReorder ? () => setShowReorderModal(true) : undefined}
            disabled={!isReorder}
            title={isReorder ? undefined : 'Not yet wired to an action'}
          >
            Take Action →
          </button>
        </div>
      </div>
      {isReorder && (
        <SuggestedReorderModal
          isOpen={showReorderModal}
          customerId={insight.customerId}
          customerName={insight.customer}
          onClose={() => setShowReorderModal(false)}
        />
      )}
    </div>
  );
};
